export default {
  zwentendorf: {
    en: 'Zwentendorf',
    fr: 'Zwentendorf',
  },
  austria: {
    en: 'Austria',
    fr: 'Autriche',
  },
  bangkok: {
    en: 'Bangkok',
    fr: 'Bangkok',
  },
  thailand: {
    en: 'Thailand',
    fr: 'Thaïlande',
  },
  dortmund: {
    en: 'Dortmund',
    fr: 'Dortmund',
  },
  trier: {
    en: 'Trier',
    fr: 'Trèves',
  },
  germany: {
    en: 'Germany',
    fr: 'Allemagne',
  },
  sydney: {
    en: 'Sydney',
    fr: 'Sydney',
  },
  australia: {
    en: 'Australia',
    fr: 'Australie',
  },
  thun: {
    en: 'Thun',
    fr: 'Thoune',
  },
  switzerland: {
    en: 'Switzerland',
    fr: 'Suisse',
  },
  montreal: {
    en: 'Montreal',
    fr: 'Montréal',
  },
  canada: {
    en: 'Canada',
    fr: 'Canada',
  },
};
